<div class="bc-chat-actions">
  <div *ngIf="isChatInProgress"
       class="chat-typing-info"
       [attr.data-automation-id]="'bc-chat-typing-info'">
    <div class="typing-list js-typing-info" [hidden]="!(typingText || isDisconnected)">
      <span *ngIf="!isDisconnected">{{ typingText | translate }}</span>
      <span *ngIf="isDisconnected">{{ 'bcChatActions.isDisconnectedNotification' | translate }}</span>
    </div>
  </div>

  <div *ngIf="(!typingText) && isChatInProgress && messages.length === 0" class="bc-empty-state">
    <span>{{ 'bcChatActions.noMessages' | translate: { visitorName: visitorName || ('bcChatActions.visitor' | translate) } }}</span>
  </div>

  <div *ngIf="isAnswerable && !isWrapUpPanelActive" class="claim-chat-panel">
    <button class="btn btn-dark center js-answer-chat-button" (click)="onAnswerChatClick()" id="chat-actions-answer-chat">
      <span>{{ 'bcChatActions.answerChatButton' | translate }}</span>
    </button>
  </div>
</div>
